<template>
	<div style="box-sizing: border-box;padding: 5px;min-height: 100%;" v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="data"
			@item-click="itemClick" v-if="data.length!=0"></v-jstree>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				data: [],
				datasource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				currentChildren: [],
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			// list() {
			// 	this.loading = true
			// 	this.modulelist = []
			// 	this.$api.goodsrevenueinfo.list({onwerid:30,currentPage:-1}).then((res)=>{
			// 		let data = res
			// 		data.forEach((item) => {
			// 			item.id = item.xwid
			// 			item.name = item.revenueName
			// 			item.parentid = item.parentxwid ? item.parentxwid : '-1'
			// 			item.icon = ''
			// 		})
			// 		data.push({
			// 			id: '-1',
			// 			name: '全部',
			// 			parentid: 0,
			// 			opened: true
			// 		})
			// 		let root = []
			// 		data.forEach((item) => {
			// 			if (item.parentid == 0) {
			// 				root.push(item)
			// 			} else {
			// 				data.forEach((_item) => {
			// 					if (item.parentid == _item.id) {
			// 						if (!_item.children) {
			// 							_item.children = []
			// 						}
			// 						_item.children.push(item)
			// 					}
			// 				})
			// 			}
			// 		})
			// 		console.log(root)
			// 		this.data = root
			// 		this.datasource = data
			// 		this.loading = false
			// 	})				
			// },
			list() {
				this.loading = true
				this.modulelist = []
				this.$api.emun.list({onwerid:30,currentPage:-1}).then((res)=>{
					let data = res.list
					data = data.filter((item) => {
						item.name = item.label
						return item.field == 'goodstype'
					})
					data.push({
						id: '-1',
						name: '全部',
						parentid: 0,
						opened: true
					})
					let list = data
					list.forEach((item) => {
						item.parentid = item.parentid || item.parentid == 0 ? item.parentid : '-1'
						item.icon = ''
					})
					let root = []
					list.forEach((item) => {
						if (item.parentid == 0) {
							root.push(item)
						} else {
							list.forEach((_item) => {
								if (item.parentid == _item.id) {
									if (!_item.children) {
										_item.children = []
									}
									_item.children.push(item)
								}
							})
						}
					})
					this.data = root
					this.datasource = data
					this.loading = false
				})				
			},
			itemClick(node, item, e) {
				this.$emit('select', {
					id: item.id,
					name: item.name,
					parentid: item.parentid,
					childrenid: item.childrenid,
					datasource: this.datasource

				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			timestampToYear(timestamp) {
				let date = new Date(timestamp)
				let year = date.getFullYear()
				return year
			}
		},
		components: {
			VJstree
		}
	}
</script>